export const ASPECT_RATIO_OPTIONS = [
  { value: '21:9', label: '21:9', description: 'Ultra-wide', width: 2560, height: 1080 },
  { value: '16:9', label: '16:9', description: 'Landscape', width: 1920, height: 1080 },
  { value: '4:3', label: '4:3', description: 'Standard', width: 1440, height: 1080 },
  { value: '1:1', label: '1:1', description: 'Square', width: 1080, height: 1080 },
  { value: '4:5', label: '4:5', description: 'Vertical', width: 1080, height: 1350 },
  { value: '9:16', label: '9:16', description: 'Portrait', width: 1080, height: 1920 },
];

export const COMPOSER_ASPECT_RATIO_OPTIONS = [
  { value: 'auto', label: 'Auto', description: 'Best fit for your prompt', w: 16, h: 9 },
  ...ASPECT_RATIO_OPTIONS.map((option) => ({
    ...option,
    description: {
      '21:9': 'Cinematic',
      '16:9': 'Landscape',
      '4:3': 'Classic',
      '1:1': 'Square',
      '4:5': 'Vertical',
      '9:16': 'Portrait',
    }[option.value],
    w: Number(option.value.split(':')[0]),
    h: Number(option.value.split(':')[1]),
  })),
];

export function appendComposerAspectRatioToPrompt(prompt, selectedAspectRatio = 'auto') {
  const choice = selectedAspectRatio || 'auto';
  if (choice === 'auto') {
    const choices = ASPECT_RATIO_OPTIONS
      .map(({ value, width, height }) => `${value} (${width}x${height})`)
      .join(', ');
    return `${prompt}\n\nSelected aspect ratio: auto (pick the best aspect ratio and corresponding project resolution yourself. Available options: ${choices})`;
  }

  const option = ASPECT_RATIO_OPTIONS.find(({ value }) => value === choice);
  const resolution = option ? `${option.width}x${option.height}` : 'use the canonical resolution for this ratio';
  return `${prompt}\n\nSelected project format: ${choice} at ${resolution}`;
}
